import { defineMessages } from 'react-intl';

export default defineMessages({
	forExample: {
		defaultMessage: 'e.g. {text}',
		description:
			'Example text used in various places, for example the date picker placeholder. "e.g. 02/12/1990"',
		id: 'cv.portal.generic.for.example',
	},
});
